import { VTooltip } from 'v-tooltip';

export default {
    directives: {
        tooltip: VTooltip,
    },
};
